import SEO from "@/components/SEO";
import { motion } from "framer-motion";

export default function CookiePolicy() {
  return (
    <>
      <SEO
        title="Cookie Policy - Kecly"
        description="Learn about how Kecly uses cookies to improve your browsing experience and website functionality."
        keywords="cookie policy, website cookies, privacy"
      />

      <div className="pt-32 pb-20">
        <div className="container mx-auto px-6">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="max-w-4xl mx-auto"
          >
            <h1 className="font-orbitron font-bold text-4xl md:text-5xl gradient-text mb-8">
              Cookie Policy
            </h1>
            
            <div className="prose prose-lg prose-invert max-w-none">
              <p className="text-muted-foreground mb-6">
                Last updated: December 2024
              </p>

              <section className="mb-8">
                <h2 className="font-orbitron font-semibold text-2xl text-primary mb-4">What Are Cookies</h2>
                <p className="text-muted-foreground mb-4">
                  Cookies are small text files stored on your device when you visit our website. They help us provide a better experience by remembering your preferences and enabling key features.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="font-orbitron font-semibold text-2xl text-primary mb-4">How We Use Cookies</h2>
                <ul className="list-disc list-inside text-muted-foreground mb-4 space-y-2">
                  <li>Essential cookies for website functionality</li>
                  <li>Analytics cookies to understand visitor behavior</li>
                  <li>Preference cookies to remember your settings</li>
                  <li>Marketing cookies for relevant advertising</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="font-orbitron font-semibold text-2xl text-primary mb-4">Managing Cookies</h2>
                <p className="text-muted-foreground mb-4">
                  You can control cookies through your browser settings. However, disabling essential cookies may affect website functionality.
                </p>
              </section>
            </div>
          </motion.div>
        </div>
      </div>
    </>
  );
}
